<template>
    <canvas  v-bind:id="id"></canvas>
</template>
<script>
export default {
    name: "grafico",
    chart: null,
    props: [ 
        'id',
        'anticipo',
        'mutuo',
        'coloreMutuo',
        'coloreAnticipo',
        'anticipoLabel',
        'mutuoLabel'
    ],

    data: function () {
        return {
            anticipoValue: this.anticipo, 
            mutuoValue: this.mutuo 
        }
    },
    mounted: function() {
        this.renderWidget();
    },
    watch: {
     
        anticipoValue: function () {
            this.renderWidget();
        },
        mutuoValue: function () {
            this.renderWidget();
        }
    },

    methods:{
        setValues: function(anticipo,mutuo){
            this.anticipoValue = anticipo;
            this.mutuoValue = mutuo;
        },

        renderWidget: function(){
            var ctx = document.getElementById(this.id).getContext('2d');

            if(this.chart != undefined)
                this.chart.destroy();

            this.chart = new Chart(ctx, {
                type: "doughnut",
                data: {
                    labels : [
                        this.anticipoLabel,
                        this.mutuoLabel
                    ],
                    datasets : [{
                        data			: [
                            this.anticipoValue,
                            this.mutuoValue
                        ],
                        backgroundColor: [
                            this.coloreMutuo,
                            this.coloreAnticipo
                        ]
                    }]
                },
                options: {
                    cutoutPercentage: 60,
                },
                legend: {
                    display: false
                }
            });
        }
    },
}
</script>
<style scoped>
    table {
        border-collapse: collapse;
    }
  
    table, th, td {
        border: 1px solid black;
    }
</style>